import { render } from "./ClockDisplayFormatField.vue?vue&type=template&id=57f8e31e"
import script from "./ClockDisplayFormatField.vue?vue&type=script&lang=js"
export * from "./ClockDisplayFormatField.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__